import React from 'react'
import dynamic from 'next/dynamic'
import TrendLinePC from './index.pc'
import useMediaQuery from 'hooks/useMediaQuery'

const TrendLineMobile = dynamic(() => import('./index.mobile'), {
  ssr: false,
  loading: () => null
})

const TrendLine = props => {
  const { isMobile } = useMediaQuery()
  return (
    <>
      {isMobile ? <TrendLineMobile {...props} /> : <TrendLinePC {...props} />}
    </>
  )
}

export default TrendLine
